import React, { useEffect } from "react";
import { Route } from "react-router-dom";

const LoginLayout = ({ children }) => (
  <div className="main-content">{children}</div>
);

const LoginLayoutRoute = ({ component: Component, ...rest }) => {
  // const temp_audit = useSelector(data => data.tempaudit);
  const data = localStorage.getItem("temp_audit");
  const temp_audit = data && JSON.parse(data);
  // console.log('run')
  useEffect(() => {
    if (temp_audit && temp_audit.audit_run_time) {
      const des_time = new Date(temp_audit.audit_run_time + 5 * 60000);
      if (des_time < new Date().getTime()) {
        // console.log('remove temp audit')
        // dispatch(removeTempAudit())
        return localStorage && localStorage.removeItem("temp_audit");
      }
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <LoginLayout>
          <Component {...matchProps} />
        </LoginLayout>
      )}
    />
  );
};
export default LoginLayoutRoute;
